import { useEffect } from 'react';
export var useSpeedcurveSnippet = function useSpeedcurveSnippet(token) {
  useEffect(function () {
    if (token) {
      var script = document.createElement('script');
      script.async = true;
      script.crossOrigin = 'anonymous';
      script.defer = true;
      script.src = "https://cdn.speedcurve.com/js/lux.js?id=".concat(token);
      document.body.appendChild(script);
      return function () {
        document.body.removeChild(script);
      };
    }
  }, []);
};